
<template>
  <div :class="['section-header', smallcaps]">
    <div class="section-header-anchor" :id="id"></div>
    <h3 :class="['number', blue]" v-if="number">{{ number }}</h3>
    <h3 v-if="first">
      {{ first }}<span v-if="second"><br />{{ second }}</span>
    </h3>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {};
  },
  props: ["first", "second", "number", "smallcaps", "blue"],
  computed: {
    id() {
      return this.first.toLowerCase().replace(/ /g, "-").replace(/[?=]/g, "");
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style>
.section-header {
  position: relative;
}

.section-header-anchor {
  position: absolute;
  top: 0;
  left: 0;
  margin-top: -8rem;
}

.section-header h3 {
  font-family: "Scala";
  font-style: italic;
  font-weight: bold;
  font-size: 3.2rem;
  line-height: 120%;
  margin: 0;
  color: #192e1f;
}

.section-header h3.number {
  color: var(--orange);
  filter: blur(0.1rem);
  letter-spacing: 1.5px;
}

.section-header h3.number.blue {
  color: var(--blue-02);
  margin-bottom: 0.5rem;
}

.section-header.smallcaps h3.number {
  font-variant: small-caps;
  font-size: 2.8rem;
}

@media (max-width: 655px) {
  .section-header h3 {
    font-size: 4rem;
  }
}
</style>
